import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withFormikField } from 'utils/formik';

import { Flexer, Icon } from '@ontruck/orc';

import { ExtraCheckbox } from 'modules/shipper-order/Form/fields';

import {
  EXTRAS_FIELD,
  LIFGATE_EXTRA,
  SIDE_LOAD_EXTRA,
  TOP_LOAD_EXTRA,
} from 'modules/shipper-order/Form/constants';

const t = {
  extras: {
    [LIFGATE_EXTRA]: 'Tail lift',
    [SIDE_LOAD_EXTRA]: 'Curtain sider',
    [TOP_LOAD_EXTRA]: 'Retractable roof',
  },
};

const VehicleRequirementsSection = ({ form }) => {
  const {
    values = {},
    setFieldValue = () => {
      /*noop*/
    },
  } = form;

  const { extras = [] } = values;

  const handleExtraChange =
    (key) =>
    (e, { value }) =>
      value
        ? setFieldValue(EXTRAS_FIELD, [...extras, key])
        : setFieldValue(
            EXTRAS_FIELD,
            extras.filter((extra) => extra !== key)
          );

  return (
    <Fragment>
      <Flexer.Child mRight="S">
        <ExtraCheckbox
          checked={extras.includes(LIFGATE_EXTRA)}
          label={
            <Fragment>
              {t.extras[LIFGATE_EXTRA]}&nbsp;&nbsp;
              <Icon glyph="extras-liftgate" color="grey500" />
            </Fragment>
          }
          onChange={handleExtraChange(LIFGATE_EXTRA)}
          dataE2E="shipperOrder_edit__liftgate"
        />
      </Flexer.Child>
      <Flexer.Child mRight="S">
        <ExtraCheckbox
          checked={extras.includes(SIDE_LOAD_EXTRA)}
          label={
            <Fragment>
              {t.extras[SIDE_LOAD_EXTRA]}&nbsp;&nbsp;
              <Icon glyph="extras-sideload" size="4rem" color="grey500" />
            </Fragment>
          }
          onChange={handleExtraChange(SIDE_LOAD_EXTRA)}
          dataE2E="shipperOrder_edit__sideload"
        />
      </Flexer.Child>
      <Flexer.Child mRight="S">
        <ExtraCheckbox
          checked={extras.includes(TOP_LOAD_EXTRA)}
          label={
            <Fragment>
              {t.extras[TOP_LOAD_EXTRA]}&nbsp;&nbsp;
              <Icon glyph="extras-retractableroof" size="4rem" color="grey500" />
            </Fragment>
          }
          onChange={handleExtraChange(TOP_LOAD_EXTRA)}
          dataE2E="shipperOrder_edit__topload"
        />
      </Flexer.Child>
    </Fragment>
  );
};

VehicleRequirementsSection.propTypes = {
  form: PropTypes.object,
};

export default withFormikField(VehicleRequirementsSection);
